













import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: true,
    },
    hasNextPage: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    previousPage: function() {
      let page = this.value - 1;
      this.changePage(page);
    },

    nextPage: function() {
      if (this.hasNextPage) {
        let page = this.value + 1;
        this.changePage(page);
      }
    },

    changePage: async function(page: number) {
      this.$emit('change-page', page);
    },
  },
});
